<template>
  <div>
    <h3>File Searches</h3>
    <form v-if="type ==='search'" @submit.prevent="loadData" class="form-horizontal">
        <div class="form-group">
            <div class="col-md-3">
                <label for="searchProjectName">Search Project Name</label>
            </div>
            <div class="col-md-4">
                <input class="form-control" type="text" name="searchProjectName" v-model="fileSearchSearchDto.projectName">
            </div>
        </div>
        <div class="form-group form-check">
            <div class="col-md-3">
                <label class="form-check-label" for="showInactive">Show Inactive Projects</label>
            </div>
            <div class="col-md-4">
                <input class="form-check-input" type="checkbox" v-model="fileSearchSearchDto.showInactive" style="width: 20px; height: 20px;">
            </div>
        </div>
        <div class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
            </div>
        </div>
    </form>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
          <loader v-if="loading"></loader>
          <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
              <template slot="edit" slot-scope="props">
                <div style="text-align: center;">
                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.fileSearchId)"></a> -->
                    <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </div>
              </template>
              <!-- <template slot="result" slot-scope="props">
                <div style="text-align: center;">
                    <a class="fa fa-edit" style="font-size: 18px;" v-on:click="resultRow(props.row.fileSearchId)"></a>
                    <router-link :to="{ path: '/FileSearchResults/' + props.row.fileSearchId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </div>
              </template> -->
            </v-client-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import fileSearchService from '../services/fileSearchService'

import loader from '../components/Loader.vue'
export default {
    components: {
        loader
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            list: null,
            fileSearchSearchDto: {
                projectName: '',
                showInactive: false
            },
            gridSpec: {
                columns: ['edit', 'fileSearchId', 'workflowStatusDescription', 'workflowStatusDate', 'createdDate', 'projectName'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate', 'workflowStatusDate'],
                    headings: {
                        edit: 'View/Edit',
                        fileSearchId: 'File Search #',
                        createdDate: 'Date of Entry',
                        workflowStatusDescription: 'Status',
                        projectName: 'Project',
                        workflowStatusDate: 'Status Date'
                        //resultLink: 'Results'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'workflowStatusDate'
                    }
                }
            }
        }
    },
    props: {
        type: {
            type: String,
            default: 'search'
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'FileSearches', 'mounted')

        this.loadData()
    },
    methods: {
        loadData () {
            if (this.type === 'search') {
                loggingService.log(this.isDebug, 'FileSearches', 'loadData - search')

                this.list = null
                fileSearchService.search(this.$http, this.fileSearchSearchDto).then(response => {
                    loggingService.log(this.isDebug, 'FileSearches', 'fileSearchService.search.then')
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else if (this.type === 'todo') {
                loggingService.log(this.isDebug, 'FileSearches', 'loadData - todo')

                this.list = null
                fileSearchService.todo(this.$http, this.fileSearchSearchDto).then(response => {
                    loggingService.log(this.isDebug, 'FileSearches', 'fileSearchService.todo.then')
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else {
                loggingService.log(this.isDebug, 'FileSearches', 'loadData - unknown type: ' + this.type)
            }
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'FileSearch', 'editRow, id: ' + id)
            this.$router.push('/FileSearch/' + id)
        },
        resultRow (id) {
            loggingService.log(this.isDebug, 'FileSearch', 'results link, id : ' + id)
            this.$router.push('/FileSearchResults/' + id)
        }

    }
}
</script>



// WEBPACK FOOTER //
// FileSearches.vue?7677fa95